import { RouteConfig } from 'vue-router';
import FeedbackDashboard from '@/modules/feedbacks/views/FeedbackDashboard.vue';
import { Actions, Resources } from '@/modules/shared/shared/domain/constants/constants';

export const feedbacksRouter: RouteConfig[] = [
    {
        path: 'feedbacks',
        name: 'feedbacks',
        component: FeedbackDashboard,
        props: true,
        meta: {
            privilege: {
                action: Actions.READ.name,
                resource: Resources.FEEDBACKS.name,
            },
        },
    },
];
